import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { C as Card } from '../Card/Card-DC98kd8r.js';
import { C as Content } from './Content/Content-CMzsFEog.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { B as Button } from '../Button/Button-BzSULnj6.js';
import { D as DefaultTitle } from './DefaultTitle/DefaultTitle-D9DozEoj.js';
import { D as DefaultFooter } from './DefaultFooter/DefaultFooter-yWVbY11t.js';
import { D as DefaultBody } from './DefaultBody/DefaultBody-DcvaxHP2.js';
import { D as DefaultImage } from './DefaultImage/DefaultImage-2nEwKHwk.js';

const StyledTitle = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40027066__sc-p8lviz-0"
})(["word-break:break-word;"]);
const StyledCard = /*#__PURE__*/styled(Card).withConfig({
  componentId: "sc-storm-ui-40027066__sc-p8lviz-1"
})(["box-sizing:border-box;", ""], ({
  $isSelected,
  theme
}) => $isSelected && css(["background-color:", ";border:", ";"], theme.selectableContainer.backgroundColor.selected, theme.selectableContainer.border.selected));
const FooterButton = /*#__PURE__*/styled(Button).attrs({
  variant: 'transparent',
  type: 'button'
}).withConfig({
  componentId: "sc-storm-ui-40027066__sc-p8lviz-2"
})(["display:flex;align-items:center;justify-content:flex-start;border-radius:", ";"], ({
  theme
}) => `0 0 0 ${theme.border.radius.large}`);
const CardListItem = ({
  id,
  className = '',
  isSelected = false,
  onSelect,
  onClick,
  title,
  footer,
  onFooterClick,
  ariaLabel,
  children,
  taktId,
  taktValue,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(StyledCard, {
  className: className,
  id: id,
  padding: "none",
  $isSelected: isSelected,
  taktId: taktId
}, /*#__PURE__*/React__default.createElement(Content, _extends({}, restProps, {
  id: id,
  isSelected: isSelected,
  onSelect: onSelect,
  onClick: onClick,
  ariaLabel: ariaLabel
}), /*#__PURE__*/React__default.createElement(StyledTitle, null, title), children), footer && /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('card-footer')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(FooterButton, _extends({}, getDataTaktAttributes(), {
  onClick: event => onFooterClick && onFooterClick(event)
}), footer)));
CardListItem.DefaultTitle = DefaultTitle;
CardListItem.DefaultFooter = DefaultFooter;
CardListItem.DefaultBody = DefaultBody;
CardListItem.DefaultImage = DefaultImage;

export { CardListItem as C };
//# sourceMappingURL=CardListItem-Bj1h5S0I.js.map
